import React, { Dispatch, SetStateAction, useState } from "react";
import { Col, Row } from "reactstrap";
import Toast from "../../helpers/Toast";
import { ValidExternalHoursDTO } from "../../models/Assistance/ValidExternalHoursDTO";
import { AssistanceService } from "../../services/AssistanceService";
import ButtonComponent from "../ButtonComponent";
import InputComponent from "../InputComponent";
import { useIntl } from "react-intl";

type ValidExternalHoursProps ={
    isComplete: boolean;
    assistanceId: number;
    setReload: Dispatch<SetStateAction<boolean>>;
    reload: boolean
}

function ValidExternalHours(props: ValidExternalHoursProps) {
    const service = new AssistanceService();
    const [rate, setRate] = useState<string>("");
    const [isLoading, SetIsLoading] = useState<boolean>(false);

    const ValidExternalHours = async () => {
        var data : ValidExternalHoursDTO ={
            assistanceId: props.assistanceId,
            rateProduct: rate,
        }

        SetIsLoading(true);
        var response = await service.ValidExternalHours(data)
        if(response.success === false)
        {
            SetIsLoading(false);
            Toast.Show("error", response.message);
            return;
        }

        SetIsLoading(false);
        props.setReload(!props.reload)
        Toast.Show("success", response.message);
    }

    const intl = useIntl();

    return (
        <div>
            <Row style={{ display: "flex" , justifyContent: "start", margin:"1rem 0px"}}>
                <InputComponent xl={4} lg={4} md={4} sm={8} xs={12} 
                    style={{ width: "100%" }}
                    type={"text"}
                    value={rate}
                    label={"Taxa"}
                    readOnly={props.isComplete === false ? isLoading : true}
                    showLoadingSkeleton={isLoading}
                    onChange={(t: string) => {
                        setRate(t);
                    }}
                />
                <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                    <ButtonComponent
                        loading={isLoading}
                        style={{ width: "100%", marginTop: "30px" }}
                        text={intl.formatMessage({ id: "ValidExternalHours.Insert" })}
                        onClick={() => ValidExternalHours()}
                        disabled={props.isComplete}
                    />
                </Col>
            </Row>
        </div>
    );
}

export default ValidExternalHours;
